import { BiDatasetAudience } from '@euler/model/bi/library';

/**
 * Who could use the dataset once the change is confirmed, as the server
 * counted them: the whole store, or each member by name.
 */
export function biDatasetAudienceLines(
  audience: BiDatasetAudience,
): Array<{ key: string; text: string }> {
  if (audience.everyone) return [{ key: 'store', text: '门店所有成员' }];
  return audience.members.map(member => ({
    key: String(member.memberId),
    text: member.name ?? `成员 ${member.memberId}`,
  }));
}
